import Topbar from "../components/layout/Topbar.jsx";
import { useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LineChart, Line } from "recharts";

// ─── REPORTS ──────────────────────────────────────────────────────
const MONTHLY_REPORTS = [
  { id:"r1", period:"Avril 2025",  tickets:28, avgH:5.2, generated:"01/05/2025", status:"sent" },
  { id:"r2", period:"Mars 2025",   tickets:31, avgH:6.1, generated:"01/04/2025", status:"sent" },
  { id:"r3", period:"Fév. 2025",   tickets:24, avgH:4.8, generated:"01/03/2025", status:"sent" },
  { id:"r4", period:"Jan. 2025",   tickets:19, avgH:3.9, generated:"01/02/2025", status:"sent" },
];
const KPI_DATA = [
  {month:"Jan",firstResp:3.2,resolution:18.5},{month:"Fév",firstResp:2.8,resolution:16.2},
  {month:"Mar",firstResp:3.5,resolution:20.1},{month:"Avr",firstResp:2.1,resolution:14.8},
  {month:"Mai",firstResp:1.9,resolution:12.3},
];
const TT = ({active,payload,label})=>active&&payload?.length?(<div style={{background:"var(--navy-mid)",border:"1px solid var(--border)",borderRadius:10,padding:"8px 12px",fontSize:12}}><div style={{color:"var(--text-2)",marginBottom:4}}>{label}</div>{payload.map((p,i)=><div key={i} style={{color:p.color,fontWeight:600}}>{p.name}: {p.value}h</div>)}</div>):null;

export function ReportsPage() {
  const [activeTab, setActiveTab] = useState("reports");
  return (
    <>
      <Topbar title="Rapports &" subtitle="KPIs"/>
      <div className="page-body">
        <div className="page-header">
          <div><div className="page-title">Rapports & <span>KPIs</span></div><div className="page-sub">Rapports mensuels et indicateurs de performance</div></div>
          <div className="page-actions">
            <button className="btn-itm btn-itm-outline"><i className="bi bi-download" /> Export Excel</button>
            <button className="btn-itm btn-itm-primary"><i className="bi bi-file-earmark-plus" /> Générer un rapport</button>
          </div>
        </div>

        <div className="itm-tabs">
          {[{id:"reports",label:"Rapports mensuels"},{id:"kpis",label:"KPIs performance"},{id:"rentability",label:"Rentabilité"}].map(t=>(
            <div key={t.id} className={`itm-tab ${activeTab===t.id?"active":""}`} onClick={()=>setActiveTab(t.id)}>{t.label}</div>
          ))}
        </div>

        {activeTab === "reports" && (
          <>
            {/* KPI cards */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:20}}>
              {[
                {icon:"bi-clock",color:"teal",  label:"Tps moyen 1ère réponse",value:"2.1h",  sub:"< 4h objectif"},
                {icon:"bi-check2",color:"green", label:"Tps moyen résolution",  value:"14.8h", sub:"< 24h objectif"},
                {icon:"bi-star",  color:"orange",label:"Satisfaction moyenne",  value:"4.6/5", sub:"> 4/5 objectif"},
                {icon:"bi-graph-up",color:"purple",label:"Tickets résolus 1er contact",value:"74%",sub:"> 70% objectif"},
              ].map((k,i)=>(
                <div key={i} className={`metric-card mc-${k.color} anim-fade-up`} style={{animationDelay:`${.05+i*.05}s`}}>
                  <div className="metric-glow"/>
                  <div className="metric-icon"><i className={`bi ${k.icon}`}/></div>
                  <div className="metric-label">{k.label}</div>
                  <div style={{fontFamily:"Syne,sans-serif",fontSize:26,fontWeight:800,color:"var(--text-1)",lineHeight:1,marginBottom:8}}>{k.value}</div>
                  <div style={{fontSize:12,color:"var(--success)"}}><i className="bi bi-check2-circle me-1"/>{k.sub}</div>
                </div>
              ))}
            </div>
            <div className="itm-card anim-fade-up delay-5">
              <div className="card-title-row"><div className="card-title">Rapports mensuels</div><div className="card-sub">Générés automatiquement le 1er du mois</div></div>
              <table className="itm-table">
                <thead><tr><th>Période</th><th>Tickets traités</th><th>Tps moyen résolution</th><th>Généré le</th><th>Statut</th><th>Actions</th></tr></thead>
                <tbody>
                  {MONTHLY_REPORTS.map(r=>(
                    <tr key={r.id}>
                      <td className="cell-primary">{r.period}</td>
                      <td style={{fontFamily:"Syne,sans-serif",fontWeight:700,color:"var(--text-1)"}}>{r.tickets}</td>
                      <td style={{color:"var(--text-2)"}}>{r.avgH}h</td>
                      <td style={{color:"var(--text-3)",fontSize:12}}>{r.generated}</td>
                      <td><span className="badge-status bs-sent">Envoyé</span></td>
                      <td>
                        <div style={{display:"flex",gap:6}}>
                          <button className="btn-icon-sm" title="Télécharger PDF"><i className="bi bi-file-earmark-pdf"/></button>
                          <button className="btn-icon-sm" title="Renvoyer par email"><i className="bi bi-envelope"/></button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        {activeTab === "kpis" && (
          <div className="itm-card anim-fade-up">
            <div className="card-title-row"><div className="card-title">Évolution des KPIs</div><div className="card-sub">5 derniers mois</div></div>
            <ResponsiveContainer width="100%" height={260}>
              <LineChart data={KPI_DATA}>
                <XAxis dataKey="month" tick={{fill:"var(--text-3)",fontSize:11}} axisLine={false} tickLine={false}/>
                <YAxis tick={{fill:"var(--text-3)",fontSize:11}} axisLine={false} tickLine={false}/>
                <Tooltip content={<TT/>} cursor={{stroke:"var(--border)"}}/>
                <Line dataKey="firstResp"  name="Première réponse" stroke="#00C2CB" strokeWidth={2} dot={{r:4,fill:"#00C2CB"}}/>
                <Line dataKey="resolution" name="Résolution"       stroke="#7C3AED" strokeWidth={2} dot={{r:4,fill:"#7C3AED"}}/>
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}

        {activeTab === "rentability" && (
          <div className="itm-card anim-fade-up">
            <div className="card-title-row"><div className="card-title">Rentabilité par client</div><div className="card-sub">Heures facturées vs consommées</div></div>
            <table className="itm-table">
              <thead><tr><th>Client</th><th>Heures incluses</th><th>Heures consommées</th><th>Solde</th><th>CA mensuel</th></tr></thead>
              <tbody>
                {[
                  {name:"ACME Corp",incl:20,used:14,rev:"450 €"},
                  {name:"Dupont SA",incl:0,used:8.5,rev:"1 275 €"},
                  {name:"Martin & Co",incl:10,used:4,rev:"350 €"},
                  {name:"Bertrand Inc",incl:15,used:11,rev:"600 €"},
                ].map(r=>(
                  <tr key={r.name}>
                    <td className="cell-primary">{r.name}</td>
                    <td style={{color:"var(--text-2)"}}>{r.incl>0?`${r.incl}h`:"Horaire"}</td>
                    <td style={{color:"var(--text-2)"}}>{r.used}h</td>
                    <td style={{color: r.incl===0?"var(--text-3)":r.incl-r.used>=0?"var(--success)":"var(--danger)", fontWeight:600}}>
                      {r.incl===0?"—":r.incl-r.used>=0?`+${r.incl-r.used}h`:`${r.incl-r.used}h`}
                    </td>
                    <td style={{fontFamily:"Syne,sans-serif",fontWeight:700,color:"var(--text-1)"}}>{r.rev}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
export default ReportsPage;
